// ==========================================================================
// App Configuration - Typed Environment Variables
// ==========================================================================

export const config = {
  // API
  apiUrl: import.meta.env.VITE_API_URL,

  // App
  appName: import.meta.env.VITE_APP_NAME,
  appEnv: import.meta.env.VITE_APP_ENV,

  // Feature Flags
  enablePwa: import.meta.env.VITE_ENABLE_PWA === 'true',
  enableMockApi: import.meta.env.VITE_ENABLE_MOCK_API === 'true',

  // Analytics
  mixpanelToken: import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined,

  // Debug
  debug: import.meta.env.VITE_DEBUG === 'true',

  // Helpers
  isLocal: import.meta.env.VITE_APP_ENV === 'local',
  isDev: import.meta.env.VITE_APP_ENV === 'development',
  isProd: import.meta.env.VITE_APP_ENV === 'production',
} as const;

export default config;
